import { createAction } from "@reduxjs/toolkit";

const tenantChanged = createAction("tenant/changed");

export default tenantChanged;
